import React, { useState, useRef , Fragment} from "react";
import Config from "../../Config";

import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";


function CalculateEdit(props)
{ 
    const [p_saldo_ma_wn_id, setSaldoId] = useState(  props.p_saldo_ma_wn_id);

    const [tab, setTab ] = useState(   null );

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

  

    
    


    const onBack = (e) => {
        props.goBack();
    }


    const goNextNew = () => {

    }


    const valChangeListener = (filedName, val, correct, msg) => { 
        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
 
        //   {"row@"+ix+"@" + ixp// 

         var sp = filedName.split('@');
 
         if(sp.length > 1)
         {                         
            var inxRow = parseInt( sp[1] );
            var inxDoP = parseInt( sp[2] );
 
            var tmp = JSON.parse(  JSON.stringify(tab) );

            var max =  parseFloat( tmp[inxRow]['do_przypisania'][inxDoP]['pozostalo'] ) ;
            val = parseFloat(val);

            console.log("XT, max: ", max, "val: ", val);

            //if(max >=0 )
            if(max > 0.00 )
            {
                if(val > max)  val = max;
            }

            if(max < 0.00 )
            {
                if(val < max) val = max;
            }


            var sugBackup =  tmp[inxRow]['do_przypisania'][inxDoP]['kwota_sugerowana'] ;  //jeśli pozostało będzie mniej niż 0.00 to przywrócimy stan poprzedni..

            tmp[inxRow]['do_przypisania'][inxDoP]['kwota_sugerowana'] = val;


            //podlicz sumę...
            //i odejmi od tego co pozostalo...

                var sumSug = 0;
                for(var k=0; k < tmp[inxRow]['do_przypisania'].length; k++)    
                {
                    if( tmp[inxRow]['do_przypisania'][k]['kwota_sugerowana'] == null )      continue;
                    if( tmp[inxRow]['do_przypisania'][k]['kwota_sugerowana'] == undefined ) continue;
                    if( tmp[inxRow]['do_przypisania'][k]['kwota_sugerowana'].length < 1 )   continue;

                    sumSug   = parseFloat(sumSug) + parseFloat( tmp[inxRow]['do_przypisania'][k]['kwota_sugerowana']  );  

                   //   console.log("POZ "+ k,  tmp[inxRow]['do_przypisania'][k]['kwota_sugerowana'] );
                }

                
            

                var razemRoz = parseFloat( tmp[inxRow]['kwota_rozliczenia']  ) + parseFloat( sumSug);
                var pozostalo = parseFloat( parseFloat( tmp[inxRow]['kwota']  ) -  parseFloat( razemRoz) ).toFixed(2) ;

        
                console.log("xPoz: ", pozostalo, " sug: ", tmp[inxRow]['do_przypisania'][inxDoP]['kwota_sugerowana'] );
                
                if(pozostalo < 0.00)//cofnij wartosc.
                {
                    tmp[inxRow]['do_przypisania'][inxDoP]['kwota_sugerowana'] = sugBackup;

                    //policz jeszcze raz..
                    sumSug = 0;
                    for(var k=0; k < tmp[inxRow]['do_przypisania'].length; k++)    
                    {
                        sumSug   = parseFloat(sumSug) + parseFloat( tmp[inxRow]['do_przypisania'][k]['kwota_sugerowana']); 
                    }
    
                    razemRoz = parseFloat( tmp[inxRow]['kwota_rozliczenia']  ) + parseFloat( sumSug);
                    pozostalo = parseFloat( tmp[inxRow]['kwota']  ) -  parseFloat( razemRoz) ;
                }




            tmp[inxRow]['pozostalo']  = parseFloat(pozostalo).toFixed(2);
                
            setTab(tmp);

             return;
         }
     
     }



  
    const goDelete = (e) => {

        //atr-row={"row@"+ix+"@" + ixp }

        var xtmp = e.target.getAttribute('atr-row');
        
        var sp = xtmp.split('@');
 
        if(sp.length > 1)
        {                         
                var inxRow = parseInt( sp[1] );
                var inxDoP = parseInt( sp[2] );
        }else
        {
            return;
        }

 

       
        var p_saldo_rozliczenia_id =  tab[inxRow]['przypisane'][inxDoP].id; //do odczepienia.. p_saldo_rozliczenia_id

  
           
        props.mainView.setProgress(-2);


        var req = {
  
            'p_saldo_rozliczenia_id': p_saldo_rozliczenia_id,
        };



    
        fetch( Config.url + '/rest_v1_calc,calc_del_c', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                getTab();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }



    const goSave = (e) => {

        //atr-row={"row@"+ix+"@" + ixp }

        var xtmp = e.target.getAttribute('atr-row');
        
        var sp = xtmp.split('@');
 
        if(sp.length > 1)
        {                         
                var inxRow = parseInt( sp[1] );
                var inxDoP = parseInt( sp[2] );
        }else
        {
            return;
        }

 
       

       
        var p_saldo_id2  =  tab[inxRow]['do_przypisania'][inxDoP].id; //do odczepienia.. p_saldo_rozliczenia_id
        var kwota        =  parseFloat( tab[inxRow]['do_przypisania'][inxDoP].kwota_sugerowana ) ; //do odczepienia.. p_saldo_rozliczenia_id
        var p_dziecko_id = -1;
        var px_group_id =  tab[inxRow].rodzic.id;
  

        if( tab[inxRow].dziecko != null)
        {
            p_dziecko_id = tab[inxRow].dziecko.id;
        }

           
        props.mainView.setProgress(-2);

        if(kwota == null || kwota == undefined )
        {
            kwota = '0';
        }

        var req = {
  
            'p_saldo_id' : tab[inxRow].id,
            'kwota'      : kwota,
            'p_saldo_id2': p_saldo_id2,
            'p_dziecko_id': p_dziecko_id,
            'px_group_id': px_group_id,
        };

        

    
        fetch( Config.url + '/rest_v1_calc,calc_add_c', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                getTab();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }


    const getTab = (e) => {
 

            props.mainView.setProgress(-2);

            var req = {
                id: p_saldo_ma_wn_id
            }


            fetch( Config.url + '/rest_v1_calc,calc_details', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            props.mainView.setProgress(-1);  
                            if(res.status == 'OK') {
                                    setTab(res.result);
                            }
                            if(res.status == 'ERROR') {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                            }

                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });

}


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }
 
    
    return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                    <br/>&nbsp;<br/>


                    {
                        tab.map(  (pozycje, ix) => {

                            var cssP = "amount_plus";
                            var txt = " [ROZLICZONE]"

                            var typX = "";

                            if(pozycje.typ == "p_przelewy") typX = "Przelew";
                            if(pozycje.typ == "f_faktura") typX = "Faktura / Rozliczenie";
                            if(pozycje.typ == "f_faktura_ods") typX = "Odsetki";
                            if(pozycje.typ == "p_saldo_ma_wn") typX = "Pozycja na saldzie";

                            if(pozycje.pozostalo != 0)  
                            {
                                 cssP = "amount_minus";
                                txt = " [NIEROZLICZONE!]"
                            }

                   

                            var stronaTmp = "Uznanie";
                            if(pozycje.strona == 'wn') stronaTmp = "Obciążenie";

                            return <Fragment>
                                    <h1 className="calColor">{ix+1 + ")   " + typX + " | " + pozycje.opis + " | " + txt }</h1>
                                 
                                    <div>
                                        {
                                            pozycje.faktura && 
                                            <div>Faktura {pozycje.faktura.numer} z dnia {pozycje.faktura.data_wystawienia} </div>
                                        }
                                        {
                                            pozycje.przelew && 
                                            <div>Przelew "{pozycje.przelew.tytul}" z dnia {pozycje.przelew.data} </div>
                                        }
                                        {
                                            pozycje.online && 
                                            <div>Przelew OnLine</div>
                                        }
                                        <br/>
                                    </div>

                                    <table className="table" >
                                                   <thead>
                                                        <tr className="header">                                                                                                                                                                                                                                                                                                                     
                                                            <td>Subkonto</td>
                                                            <td>Rodzic</td>                                                                                                                             
                                                            <td>Dziecko</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                            <td>Typ</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                            <td>Kwota</td>                                                                                                                             
                                                            <td>Kwota rozliczenia (SUMA)</td>                                                                                                                             
                                                            <td>Pozostało</td>                                                                                                                             
                                                            <td> </td>                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                              
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                    

                                                        <tr className="row">                                                                                                                                                                                                                                                                                                                                                  
                                                            <td>{pozycje.subkonto.nazwa + " / " + pozycje.subkonto.numer_konta}</td>

                                                            <td>{pozycje.rodzic.nazwisko + " " +  pozycje.rodzic.imie }</td>                                                                                                                                                                                                                                                                                                                     

                                                            <td>
                                                                {
                                                                    pozycje.dziecko != null &&
                                                                    <Fragment>
                                                                       <span className="kid_color"> {pozycje.dziecko.nazwisko + " " + pozycje.dziecko.imie} </span>
                                                                    </Fragment>
                                                                }
                                                            </td>   

                                                            <td className="gocenter">{stronaTmp}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       

                                                            <td className="goright" ><FormatDecimal value={pozycje.kwota} /></td>                                                                                                                             
                                                            <td className="goright amount_plus"><FormatDecimal value={pozycje.kwota_rozliczenia} /></td>                                                                                                                             
                                                            <td className={"goright gobold " +  cssP}><FormatDecimal value={pozycje.pozostalo} /></td>                                                                                                                                
                                                            <td  > - </td>                                                                                                                                
                                                                                                                                                                                                                                                                                                                                                                      
                                                        </tr>

                                                        <tr>
                                                            <td colspan="8" className="gobold">
                                                               Aktualnie przypisane  pozycje ({pozycje.przypisane.length}):
                                                            </td>
                                                        </tr>   

                                                        {
                                                            pozycje.przypisane.length == 0 &&
                                                            <tr>
                                                                <td colSpan="8"> --- </td>
                                                            </tr>
                                                        }

                                                        {
                                                            pozycje.przypisane.map( (pp, ixp) => {
                                                                            return   <tr>
                                                                            <td colSpan="5" className="goright amount_plus">
                                                                                &nbsp; <br/>
                                                                                kwota: {pp.saldo.kwota},     {pp.saldo.opis}, strona: {pp.saldo.strona},  data: {pp.saldo.data}, rodzic: {pp.rodzic.nazwisko} {pp.rodzic.imie}

                                                                                {
                                                                                    pp.faktura &&
                                                                                    <div>
                                                                                        <b>Faktura:</b> {pp.faktura.numer} z dnia {pp.faktura.data_wystawienia}
                                                                                    </div>
                                                                                }

                                                                                {
                                                                                    pp.przelew && 
                                                                                    <div>
                                                                                        <b>Przelew:</b> <span className="">{pp.przelew.tytul} z dnia  {pp.przelew.data} </span>
                                                                                    </div>
                                                                                }

                                                                                {
                                                                                    pp.dziecko && 
                                                                                    <div>
                                                                                        <b>Dziecko:</b> <span className="kid_color">{pp.dziecko.nazwisko} {pp.dziecko.imie} </span>
                                                                                    </div>
                                                                                }
                                                                                &nbsp;<br/>


                                                                            </td>
                                                                            <td className="goright amount_plus">
                                                                               <FormatDecimal value={pp.kwota_roz_pozycji} />
                                                                            </td>
                                                                            <td>  </td>
                                                                            <td className="gocenter">
                                                                                <span className="link_color" atr-row={"row@"+ix+"@" + ixp }   onClick={goDelete} >usuń</span>
                                                                            </td>
                                                                    </tr>   
                                                            } )
                                                        }            

                                                        <tr>
                                                            <td colspan="8" className="gobold">
                                                               Pozycje do przypisania ({pozycje.do_przypisania.length}): 
                                                            </td>
                                                        </tr> 


                                                        {
                                                            pozycje.do_przypisania.map( (pp, ixp) => {
                                                                            return   <tr>
                                                                            <td colSpan="5" className="goright">
                                                                                &nbsp;<br/>
                                                                                kwota: {pp.kwota},     {pp.opis} ,  data: {pp.data}, rodzic: {pp.rodzic.nazwisko} {pp.rodzic.imie}, strona: {pp.strona}
                                                                                {
                                                                                    pp.faktura &&
                                                                                    <div>
                                                                                        <b>Faktura:</b> {pp.faktura.numer} z dnia {pp.faktura.data_wystawienia}
                                                                                    </div>
                                                                                }

                                                                                {
                                                                                    pp.przelew && 
                                                                                    <div>
                                                                                        <b>Przelew:</b> <span className="">{pp.przelew.tytul} z dnia  {pp.przelew.data} </span>
                                                                                    </div>
                                                                                }

                                                                                {
                                                                                    pp.dziecko && 
                                                                                    <div>
                                                                                        <b>Dziecko:</b> <span className="kid_color">{pp.dziecko.nazwisko} {pp.dziecko.imie} </span>
                                                                                    </div>
                                                                                }
                                                                                &nbsp;<br/>
                                                                                <b>do wykorzystania:  <FormatDecimal value={pp.pozostalo} /></b>
                                                                                <br/>&nbsp;
                                                                            </td>
                                                                            <td className="goright">
                                                                               ---
                                                                            </td>
                                                                            <td className="goright filter_merge_empty">
                                                                                <InputDecimal   userData={props.userData} value={pp.kwota_sugerowana} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"row@"+ix+"@" + ixp } placeholder={"Kwota:"} className='w100' req='0'   />
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    pp.kwota_sugerowana != 0 &&
                                                                                    <span className="link_color" atr-row={"row@"+ix+"@" + ixp }   onClick={goSave}   >zapisz</span>
                                                                                }

                                                                                {
                                                                                    pp.kwota_sugerowana == 0 &&
                                                                                    <span   > &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;</span>
                                                                                }
                                                                               
                                                                            </td>
                                                                    </tr>   
                                                            } )
                                                        } 
                                                           

                                                    </tbody>
                                    </table>

                                    

                                    <br/>
                                    <br/>
                                    <br/>
                            </Fragment>


                        } )

                    }

            </div>

}


export default CalculateEdit;

